import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhyChoose } from './components/WhyChoose';
import { Booking } from './components/Booking';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream font-sans" data-id="element-0" data-mp="2riko97zkgfcl">
      <Header data-id="element-1" data-mp="2mmvl6uoc8gbj" />
      <main data-id="element-2" data-mp="2mn5fgugf19n1">
        <Hero data-id="element-3" data-mp="2mnnhy8to8k3e" />
        <About data-id="element-4" data-mp="2mjzmh44o1nm1" />
        <Services data-id="element-5" data-mp="31aqhel1k12td" />
        <WhyChoose data-id="element-6" data-mp="31b8fzobovt4g" />
        <Booking data-id="element-7" data-mp="31bibfrfi6shj" />
        <Gallery data-id="element-8" data-mp="31c1i2bzpdug9" />
        <Testimonials data-id="element-9" data-mp="31cjn9y4cfj0b" />
      </main>
      <Footer data-id="element-10" data-mp="2wjgtppzkg9k4" />
    </div>;
}